import script from "./editInviteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./editInviteForm.vue?vue&type=script&setup=true&lang=js"

import "./editInviteForm.vue?vue&type=style&index=0&id=6e2877e7&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e2877e7"]])

export default __exports__